import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  // const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('No token');
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/dashboard`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        localStorage.removeItem('token');
        navigate('/login');
        setUser(null);
      } finally {
        // setLoading(false);
      }
    };
    fetchUser();
  }, [navigate]);

  // if (loading) return <div>Loading...</div>;

  // if (!user) return <Navigate to="/login" />;

  if (user && adminOnly && user?.role !== "admin") return <Navigate to="/dashboard" />;

  return children;
};

export default ProtectedRoute;